import { render, staticRenderFns } from "./CommentUnder.vue?vue&type=template&id=002349fc&scoped=true&"
import script from "./CommentUnder.vue?vue&type=script&lang=js&"
export * from "./CommentUnder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002349fc",
  null
  
)

export default component.exports